import { useQuery } from "@tanstack/react-query";
import { PageHeader } from "@/components/dashboard/shared/PageHeader";
import { KpiCard } from "@/components/dashboard/shared/KpiCard";
import { KpiGrid } from "@/components/dashboard/shared/KpiGrid";
import { OrderList } from "@/components/dashboard/orders/OrderList";
import { DashboardHead } from "@/components/SEO/DashboardHead";
import api from "@/utils/api";
import { useCurrentStore } from "@/hooks/useCurrentStore";
import {
  RiPulseLine,
  RiLineChartLine,
  RiTimeLine,
  RiCheckboxCircleLine,
  RiCloseCircleLine,
} from "@remixicon/react";

type OrderStats = {
  totalOrders: number;
  totalRevenue: number;
  pendingOrders: number;
  deliveredOrders: number;
  cancelledOrders: number;
};

export function OrdersPage() {
  const searchTerm = "";
  const statusFilter = "all";
  const { storeId, currentStore } = useCurrentStore();

  const { data: stats, isLoading } = useQuery<OrderStats>({
    queryKey: ["orders-stats", storeId],
    queryFn: async () => {
      const { data } = await api.get("/api/analytics/orders/stats");
      return data;
    },
    enabled: !!storeId,
  });

  return (
    <div className="space-y-6">
      <DashboardHead pageName="Orders" />
      <PageHeader title="Orders" subtitle="Track and fulfill customer orders." />

      <KpiGrid
        loading={isLoading}
        skeletonCount={5}
        columns="grid-cols-1 sm:grid-cols-2 xl:grid-cols-5"
      >
        <KpiCard
          label="Total Orders"
          value={stats?.totalOrders ?? 0}
          icon={<RiPulseLine />}
        />
        <KpiCard
          label="Total Revenue"
          value={stats?.totalRevenue ?? 0}
          currency={currentStore?.currency || "NGN"}
          icon={<RiLineChartLine />}
        />
        <KpiCard
          label="Pending"
          value={stats?.pendingOrders ?? 0}
          icon={<RiTimeLine />}
        />
        <KpiCard
          label="Delivered"
          value={stats?.deliveredOrders ?? 0}
          icon={<RiCheckboxCircleLine />}
        />
        <KpiCard
          label="Cancelled"
          value={stats?.cancelledOrders ?? 0}
          icon={<RiCloseCircleLine />}
        />
      </KpiGrid>

      <OrderList searchTerm={searchTerm} statusFilter={statusFilter} />
    </div>
  );
}
